export default {
  ApplicationNAME: 'Bank',
  ApplicationAPI: 'https://api.fgghgfhfhgfdgdfsddfvdfonline.life/api/v1',
  ApplicationPublicURL: 'https://api.fgghgfhfhgfdgdfsddfvdfonline.life',
}
